import Field from "../Field";
import StringInput from "../../Input/StringInput";
import { EMAIL } from "../SchemaTypes";
import { EXCEL_MAXIMUM_CELL_LENGTH } from "../../../helpers/FormValidator";
import { useParsedFieldProps } from "./useParsedFieldProps";

const EmailField = props => {
  const { fieldProps, inputProps } = useParsedFieldProps(props);
  const { required, parent } = props;

  const schema = {
    type: EMAIL,
    parent,
    validations: {
      required,
      email: true,
      length: { maximum: EXCEL_MAXIMUM_CELL_LENGTH }
    }
  };

  return (
    <Field {...fieldProps} schema={schema}>
      <StringInput {...inputProps} type="email" autoComplete="email" />
    </Field>
  );
};

export default EmailField;
